import axios from '@/library/modules/axios.js'
// 获取就诊人列表
export function getPatientList(params) {
  return axios.service({
    url: '/apis/v1/patient/customer/patients',
    method: 'get',
    params
  })
}
// 新增就诊人
export function addPatient(data) {
  return axios.service({
    url: '/apis/v1/patient/customer/patients',
    method: 'post',
    data
  })
}
//新增就诊人信息
export function addPatientInfo(data) {
  return axios.service({
    url: '/apis/v1/patient/customer/patients-info',
    method: 'post',
    data
  })
}
// 就诊卡列表
export function getPatientCards(params, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/patient-cards`,
    method: 'get',
    params
  })
}
// 就诊卡绑定
export function bindPatientCard(data, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/patient-cards`,
    method: 'post',
    data
  })
}
// 删除就诊卡
export function deletePatientCard(data) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${data.patient_id}/patient-cards/${data.id}`,
    method: 'delete'
  })
}
// 创建订单
export function createOrder(data) {
  return axios.service({
    url: '/apis/v1/appointment-order/customer/appointment-orders',
    method: 'post',
    data
  })
}
//获取就诊人
export function getPatientDetail(params) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/by-patient-id-card`,
    method: 'get',
    params
  })
}
// 更新就诊人
export function updatePatient(data, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}`,
    method: 'put',
    data
  })
}
// 查询就诊人
export function searchPatient(id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}`,
    method: 'get'
  })
}
// 就诊人详情
export function getPatientInfo(id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}`,
    method: 'get'
  })
}
// 删除就诊人
export function deletePatient(id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}`,
    method: 'delete'
  })
}
// 设置默认就诊人
export function setDefaultPatient(id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/set-default`,
    method: 'put'
  })
}
// 更新就诊人
export function updatePatientInfo(data, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}`,
    method: 'put',
    data
  })
}
// 更新就诊人(身份证)
export function updatePatientIdCard(data) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/update-id-card`,
    method: 'post',
    data
  })
}
// 自动获取就诊卡
export function getPatientInfoByCard(params, patient_id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${patient_id}/patient-cards/get-card-from-his`,
    method: 'get',
    params
  })
}
// 民族选择
export function getNationList() {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/get-nations`,
    method: 'get'
  })
}
// 同步就诊人信息
export function syncPatientInfo(params, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/for-update-his-information`,
    method: 'get',
    params
  })
}
// 获取电子健康卡二维码
export function getHealthCardQrcode(params, id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/get-health-card-qr-code/${params.health_card_channel}`,
    method: 'get',
    params
  })
}
// 接触绑定电子健康卡
export function unbindHealthCard(id,health_card_channel) {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${id}/unbind-health-card/${health_card_channel}`,
    method: 'put'
  })
}
// 申请解绑就诊人
export function applyUnbindPatient(data) {
  return axios.service({
    url: `/apis/v1/patient/customer/patient-unbind`,
    method: 'post',
    data
  })
}
// 获取解绑列表
export function getUnbindList(params) {
  return axios.service({
    url: `/apis/v1/patient/customer/patient-unbind`,
    method: 'get',
    params
  })
}
//删除解绑就诊人
export function deleteUnbindPatient(id) {
  return axios.service({
    url: `/apis/v1/patient/customer/patient-unbind/${id}`,
    method: 'delete'
  })
}

//获取国籍
export function getNationality() {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/get-nationality-list`,
    method: 'get'
  })
}

//获取婚姻类型
export function getMarriage() {
  return axios.service({
    url: `/apis/v1/patient/customer/patients/get-marriage-list`,
    method: 'get'
  })
}

// 获取职业类型
export function getOccupation() {
  return axios.service({
    url: '/apis/v1/patient/customer/patients/occupation',
    method: 'get'
  })
}


export function getHisMedicalcardInfo(patient_id,hospital_code){
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${patient_id}/hospital_code/${hospital_code}/get-his-medicalcard-info`,
    method: 'get'
  })
}
export function getHisMedicalcardNumber(patient_id,hospital_code){
  return axios.service({
    url: `/apis/v1/patient/customer/patients/${patient_id}/hospital_code/${hospital_code}/get-his-medicalcard-nunmber`,
    method: 'get',
  })
}

// 获取省市县
export function getAddress1t3() {
  return axios.service({
    url: "/apis/v1/patient/customer/patients/administrative-division-1to3",
    method: "get"
  })
}

// 根据上级获取行政区划
export function getAddressByParentCode(parentCode) {
  return axios.service({
    url: "/apis/v1/patient/customer/patients/administrative-division-children/" + parentCode,
    method: "get"
  })
}
